import React from 'react';
import {Route, Redirect} from "react-router-dom";
import {pisAuthenticated} from "./partnerIndex";

const PartnerRoute = ({ component: Component, ...rest }) =>  {
    return (
      <Route
        {...rest}
        render={props =>
         pisAuthenticated() ? (
            <Component {...props} />
            ) : (
            <Redirect
              to={{
                pathname: "/partnerSignin",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }

  export default PartnerRoute;